var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 205.555,
    height: 205.645,
    viewBox: "0 0 205.555 205.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2bb673;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M349.569,286.777v-.308c0-.7,0-1.411-.042-2.073,0-.4-.045-.794-.045-1.234,0-.4-.045-.8-.045-1.192-.045-.485-.045-.97-.087-1.456,0-.308-.045-.617-.045-.925L349.174,278c0-.218-.045-.485-.045-.7-.045-.575-.132-1.147-.177-1.764,0-.135-.045-.308-.045-.443a102.78,102.78,0,0,0-204.231.045c0,.132-.045.308-.045.44-.045.575-.132,1.147-.177,1.764a3.732,3.732,0,0,0-.045.707l-.132,1.587c0,.308-.045.62-.045.929-.042.485-.042.97-.087,1.456,0,.4-.045.794-.045,1.189s-.045.794-.045,1.237c0,.7-.042,1.411-.042,2.073v.707c0,.7,0,1.411.042,2.073,0,.4.045.794.045,1.234,0,.4.045.794.045,1.192.045.485.045.97.087,1.456,0,.308.045.617.045.925l.132,1.587c0,.222.045.485.045.707.045.572.132,1.147.177,1.764,0,.132.045.308.045.44a102.786,102.786,0,0,0,204.231-.042c0-.135.045-.308.045-.443.045-.572.132-1.147.177-1.764a3.7,3.7,0,0,0,.045-.7l.132-1.591c0-.308.045-.617.045-.925.042-.485.042-.97.087-1.456,0-.4.045-.794.045-1.192s.045-.794.045-1.234c0-.707.042-1.411.042-2.073v-.4Z",
    transform: "translate(-144.014 -184)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144.014 -184)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 97.348,
    height: 13.233,
    transform: "translate(223.411 321.047) rotate(-44.98)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13.233,
    height: 49.344,
    transform: "translate(197.429 295.956) rotate(-45)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.86e5250b5c9dfac02c01aaf3d8169a26.svg";
export { ForwardRef as ReactComponent };